import { render, staticRenderFns } from "./NotesCaption.vue?vue&type=template&id=763da0df&scoped=true"
import script from "./NotesCaption.vue?vue&type=script&lang=js"
export * from "./NotesCaption.vue?vue&type=script&lang=js"
import style0 from "./NotesCaption.vue?vue&type=style&index=0&id=763da0df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763da0df",
  null
  
)

export default component.exports